import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { PassiveScroll } from "@faire/retailer-visitor-shared/components/Scroll/Scroll";
import { MarketEventDirectSection } from "@faire/retailer-visitor-shared/features/FaireMarkets/FaireDirect/MarketEventDirectSection";
import { ProspectingSampleBannerAndModals } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/ProspectingSampleBannerAndModals";
import { ProspectingSampleSignupFlow } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/ProspectingSampleSignupFlow";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { getExternalSalesRepName } from "@faire/retailer-visitor-shared/serialized-data/getExternalSalesRepName";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useFaireDirectLandingPagePopSignUpEffect } from "@faire/retailer-visitor-shared/views/faire-direct/__internal__/useFaireDirectLandingPagePopSignUpEffect";
import { PageWrapper } from "@faire/retailer-visitor-shared/views/faire-direct/components/PageWrapper";
import { SignUpNavComponent } from "@faire/retailer-visitor-shared/views/faire-direct/components/SignUpNavComponent";
import { BrandPreviewSection } from "@faire/retailer-visitor-shared/views/faire-direct/sections/BrandPreviewSection";
import { FooterSignUp } from "@faire/retailer-visitor-shared/views/faire-direct/sections/FooterSignUp";
import { IntroSection } from "@faire/retailer-visitor-shared/views/faire-direct/sections/IntroSection";
import { NewsSection } from "@faire/retailer-visitor-shared/views/faire-direct/sections/NewsSection";
import { PerksSection } from "@faire/retailer-visitor-shared/views/faire-direct/sections/PerksSection/PerksSection";
import { QuoteSection } from "@faire/retailer-visitor-shared/views/faire-direct/sections/QuoteSection";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { Path } from "@faire/web--source/common/Path";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { trackFaireDirectFaireDirectLandingPageLoadView } from "@faire/web-api--source/events/faireDirect/view/faireDirectLandingPageLoad";
import { trackFaireDirectSignUpLandingPageView } from "@faire/web-api--source/events/faireDirect/view/signUpLandingPage";
import { QueryParameters as FaireDirectQueryParameters } from "@faire/web-api--source/routes/user/sign-up";
import * as React from "react";
import { useRef, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
export var FaireDirectLandingPage = function(param) {
    var faireDirectBrandToken = param.faireDirectBrandToken, faireDirectBrand = param.faireDirectBrand;
    useFaireDirectLandingPagePopSignUpEffect();
    var _useQueryParams = useQueryParams(FaireDirectQueryParameters.parse), signUp = _useQueryParams.signUp, email = _useQueryParams.email;
    var oet = useQueryParams(function(search) {
        var queryParams = search ? parseQueryParams(search) : undefined;
        var _queryParams_get;
        var oet = (_queryParams_get = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("oet")) !== null && _queryParams_get !== void 0 ? _queryParams_get : undefined;
        return {
            oet: oet
        };
    }).oet;
    var location = useLocation();
    var currentPath = new Path(location);
    var loginUrl = currentPath.append({
        signIn: "1"
    }).toString();
    var isPreSample = signUp === SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE;
    var _useState = _sliced_to_array(useState(false), 2), showNav = _useState[0], setShowNav = _useState[1];
    var signupReference = useRef(null);
    var _useState1 = _sliced_to_array(useState(false), 2), hasSeenIntro = _useState1[0], setHasSeenIntro = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), pageViewRecorded = _useState2[0], setPageViewRecorded = _useState2[1];
    var signUpNavRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("signUpNav");
    });
    var introRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("intro");
        setHasSeenIntro(true);
    });
    var brandPreviewRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("brandPreview");
    });
    var perksRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("perks");
    });
    var eventRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("event");
    });
    var quotesRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("quotes");
    });
    var newsRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("news");
    });
    var footerSignUpRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("footerSignUp");
    });
    var footerRef = useDoActionWhenVisible(function() {
        trackSectionViewEvent("footer");
    });
    var faireDirectBrandAlias = useFaireDirectBrand().faireDirectBrandAlias;
    var handleOnScroll = useCallback(function() {
        if (signupReference && signupReference.current) {
            var _signupReference_current = signupReference.current, offsetTop = _signupReference_current.offsetTop, clientHeight = _signupReference_current.clientHeight;
            var isBelowSignup = getWindowOrThrow().scrollY > offsetTop + clientHeight;
            if (showNav !== isBelowSignup) {
                setShowNav(isBelowSignup);
            }
        }
    }, [
        showNav
    ]);
    useEffect(function() {
        handleOnScroll();
    }, [
        handleOnScroll
    ]);
    useEffect(function() {
        var cleanupTimeout = null;
        if (!pageViewRecorded && hasSeenIntro) {
            var _setTimeoutIfPossible;
            cleanupTimeout = (_setTimeoutIfPossible = setTimeoutIfPossible(function() {
                trackFaireDirectFaireDirectLandingPageLoadView(faireDirectBrandAlias !== null && faireDirectBrandAlias !== void 0 ? faireDirectBrandAlias : "");
                setPageViewRecorded(true);
            }, 2000)) !== null && _setTimeoutIfPossible !== void 0 ? _setTimeoutIfPossible : null;
        }
        return function() {
            if (cleanupTimeout != null) {
                clearTimeout(cleanupTimeout);
            }
        };
    }, [
        faireDirectBrandAlias,
        pageViewRecorded,
        hasSeenIntro
    ]);
    useEffect(function() {
        trackFaireDirectSignUpLandingPageView(faireDirectBrandAlias !== null && faireDirectBrandAlias !== void 0 ? faireDirectBrandAlias : "");
        if (getExternalSalesRepName()) {
            trackEvent("faire-direct-sign-up/landing-page/rep/".concat(getExternalSalesRepName(), "/view/source/").concat(oet));
        } else {
            trackEvent("faire-direct-sign-up/landing-page/view/source/".concat(oet));
        }
    }, [
        oet,
        faireDirectBrandAlias
    ]);
    var showFaireDirectBanner = useMarketStore([
        "showFaireDirectBanner"
    ]).showFaireDirectBanner;
    if (isPreSample && email) {
        return /*#__PURE__*/ _jsx(PageWrapper, {
            loginUrl: loginUrl,
            isPreSample: isPreSample,
            children: /*#__PURE__*/ _jsx(ProspectingSampleSignupFlow, {
                brand: faireDirectBrand,
                email: email
            })
        });
    }
    return /*#__PURE__*/ _jsxs(PageWrapper, {
        loginUrl: loginUrl,
        isPreSample: isPreSample,
        children: [
            /*#__PURE__*/ _jsx(ProspectingSampleBannerAndModals, {
                isPreSample: isPreSample,
                brand: faireDirectBrand
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: signUpNavRef,
                children: /*#__PURE__*/ _jsx(SignUpNavComponent, {
                    brandName: faireDirectBrand.name || "",
                    showNav: showNav,
                    eventRoot: "faire-direct-sign-up"
                })
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: introRef,
                children: /*#__PURE__*/ _jsx(IntroSection, {
                    brand: faireDirectBrand,
                    isPreSample: isPreSample,
                    innerRef: signupReference,
                    loginUrl: loginUrl
                })
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: brandPreviewRef,
                children: /*#__PURE__*/ _jsx(BrandPreviewSection, {
                    brand: faireDirectBrand,
                    brandToken: faireDirectBrandToken,
                    pageJsExecutedMark: PAGE_JS_EXECUTED_MARK
                })
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: perksRef,
                children: /*#__PURE__*/ _jsx(PerksSection, {})
            }),
            showFaireDirectBanner ? /*#__PURE__*/ _jsx(RefContainer, {
                ref: eventRef,
                children: /*#__PURE__*/ _jsx(MarketEventDirectSection, {
                    brandToken: faireDirectBrandToken
                })
            }) : null,
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: quotesRef,
                children: /*#__PURE__*/ _jsx(QuoteSection, {
                    backgroundColor: Decorative.tint.neutral
                })
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: newsRef,
                children: /*#__PURE__*/ _jsx(NewsSection, {})
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: footerSignUpRef,
                children: /*#__PURE__*/ _jsx(FooterSignUp, {
                    brand: faireDirectBrand,
                    loginUrl: loginUrl
                })
            }),
            /*#__PURE__*/ _jsx(RefContainer, {
                ref: footerRef,
                children: /*#__PURE__*/ _jsx(FooterSEOContent, {})
            }),
            /*#__PURE__*/ _jsx(PassiveScroll, {
                onScroll: throttleIfPossible(handleOnScroll, 200)
            })
        ]
    });
};
var RefContainer = styled.div.withConfig({
    componentId: "sc-2c20c09-0"
})([
    "width:100%;"
]);
var trackSectionViewEvent = function(sectionKey) {
    return trackEvent("fd-landing/scroll/".concat(sectionKey));
};
